import '@blueprintjs/core/lib/css/blueprint.css';
import "./select.css";
import React from "react";
import { Icon, FormGroup, HTMLSelect } from "@blueprintjs/core";
import { I18n } from "react-redux-i18n";


const Select = (props) => {
  return (
    <FormGroup
      label={props.label}
      labelFor="text-input"
      className="select-section"
    >
      <HTMLSelect
        id={props.id}
        className="text-input"
        options={props.options}
        value={props.value}
        onChange={props.onChange}
        required={props.required}
      >
        {props.countries && (
          <>
            <option value="All">País</option>
            {props.countries.map((item, index) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
          </>
        )}
        {props.countriesCounter && (
          <>
            <option value="All">País</option>
            {props.countriesCounter.map((item, index) => (
              <option key={item.code} value={item.code}>
                {item.name} (
                {
                  props.cardsList.filter((v) => v.address.country === item.name)
                    .length
                }
                )
              </option>
            ))}
          </>
        )}

        {props.values && props.filter && <option value="">All Clients</option>}

        {(props.listOwners || props.values) && props.admin && !props.filter && (
          <option value=""></option>
        )}

        {props.values &&
          props.values.map((item, index) =>
            props.admin ? (
              <option key={index} value={item.ownerId}>
                {item.name}
              </option>
            ) : (
              <option key={index} value={item.code}>
                {item.name}
              </option>
            )
          )}

        {props.listOwners &&
          props.admin &&
          props.listOwners.map((item, index) => (
            <option key={index} value={`id-${item.ownerId}`}>
              {item.name}
            </option>
          ))}

        {props.listOperator && (
          <>
            <option value="">{props.filterPlaceholder}</option>
            {props.listOperator.map((item, index) => (
              <option key={index} value={item.valueId}>
                {item.valueName}
              </option>
            ))}
          </>
        )}

        {props.listChargingStation && (
          <>
            <option value="" key="default-value">
              {props.filterPlaceholder}
            </option>
            {props.listChargingStation.map((item, index) => (
              <option
                value={
                  item.ownerId
                    ? item.ownerId
                    : item.userId
                    ? item.userId
                    : item._id
                    ? item._id
                    : item.hwId
                    ? item.hwId
                    : ""
                }
                key={index}
              >
                {item.owner ? item.owner : item.name}
              </option>
            ))}
          </>
        )}

        {props.files && (
          <>
            <option value="" key="default-value">
              Selecione um ficheiro
            </option>
            {props.files.map((item, index) => (
              <option key={index} value={item.content}>
                {item.name}
              </option>
            ))}
          </>
        )}

        {props.plugs && (
          <>
            <option value="" key="default-value">
              Selecione o Plug
            </option>
            {props.plugs.map((item, index) => (
              <option
                key={index}
                value={item.plugId}
              >{`Plug ${item.plugId}`}</option>
            ))}
          </>
        )}

        {props.systemLog && (
          <>
            <option value="" key="default-value">
              {props.title}
            </option>
            {props.systemLog.map((item, index) => (
              <option key={index} value={item}>
                {I18n.t(item)}
              </option>
            ))}
          </>
        )}
      </HTMLSelect>
    </FormGroup>
  );
};

export default Select;
